import {
  ImageList,
  ImageListItem,
  LinearProgress,
  Typography,
} from "@material-ui/core";
import { useContext, useEffect, useState } from "react";
import { Image } from "../../../../shared/types";
import { PhotoActions } from "../../actions/photos";
import { sanitizeImgUrls } from "../../helpers/functions";
import { ErrorContext } from "../../providers/ErrorContextProvider";
import { FileUploader } from "../components/FileUploader";

const PhotosPage = () => {
  const [photos, setPhotos] = useState<Image[]>([]);
  const [loading, setLoading] = useState(true);

  const errorContext = useContext(ErrorContext);

  useEffect(() => {
    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
    const response = await PhotoActions.get();

    const data: Image[] = response.map((p) => ({
      path: `/${p}`,
    }));
    setPhotos(data);
    setLoading(false);
  };

  return (
    <>
      <Typography>Fotos</Typography>

      <FileUploader
        path="/scripts/imageUploadScript.php"
        uploadText={"Subir"}
        selectFileText={"Seleccionar imágen"}
        onUpload={(p) =>
          setPhotos([
            {
              path: p,
            },
            ...photos,
          ])
        }
        onError={(m) => {
          errorContext.setMessage(m);
        }}
      />
      {loading ? (
        <LinearProgress />
      ) : (
        <ImageList cols={3} rowHeight={164}>
          {photos.map((i) => (
            <ImageListItem key={i.path}>
              <img src={sanitizeImgUrls(i.path)} alt={i.path} loading="lazy" />
            </ImageListItem>
          ))}
        </ImageList>
      )}
    </>
  );
};

export default PhotosPage;
